export class SkechersCoLineRequest {

    poNumber?: string;
    itemNo?: string;
    poStyle?: string;
    price?: string;



    constructor(
        poNumber?: string, itemNo?: string, poStyle?: string, price?: string

    ) {

        this.poNumber = poNumber;
        this.itemNo = itemNo;
        this.poStyle = poStyle
        this.price = price
    }
}
